<ll-toolnavbar>
    <asociacion-toolnavbar [asociacionId]="asociacionId" [displayButtons]="'all new edit'"></asociacion-toolnavbar>
</ll-toolnavbar>
<ll-titulo>Asociación</ll-titulo>

<asociacion [asociacionId]="asociacionId"></asociacion>
